import { render } from "./Paw.vue?vue&type=template&id=18934387&scoped=true"
import script from "./Paw.vue?vue&type=script&lang=js"
export * from "./Paw.vue?vue&type=script&lang=js"

import "./Paw.vue?vue&type=style&index=0&id=18934387&scoped=true&lang=css"

import exportComponent from "/Users/ergishoxha/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18934387"]])

export default __exports__